import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setShowNavbar, setShowFriends } from "../stores/uiState/UiStateSlice";

function About() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowNavbar(true));
    dispatch(setShowFriends(true));
  }, []);

  return (
    <section className="About">
      <div className="heroContainer">
        <div className="headerContainer">
          <h1 className="title">
            About <span className="DrafterTitle">Drafter</span>
          </h1>
          <h2 className="headline">
            Learn more about the first League of Legends drafting game
          </h2>
        </div>
        <div className="descriptionWrapper">
          <div className="descriptionContainer">
            <h3 className="descriptionTitle">What is Drafter?</h3>
            <h2 className="description">
              Drafter is a game where you can draft a selection of champions
              like a League of Legends coach, and our algorithm will determine
              which team has the highest probability of winning.
            </h2>
          </div>
          <div className="descriptionContainer">
            <h3 className="descriptionTitle">
              What determines the outcome of a match?
            </h3>
            <h2 className="description">
              <p className="needSpace">
                The algorithm is based exclusively on professional competitive
                games. It analyzes every interaction between the 10 selected
                champions, weighted by their impact on the current meta.
              </p>
              <p>
                Champions that are rarely picked in competitive play will have
                little to no data backing them, so the algorithm may be less
                accurate for unusual or off-meta picks.
              </p>
            </h2>
          </div>
          <div className="descriptionContainer">
            <h3 className="descriptionTitle">How to get better at Drafter?</h3>
            <h2 className="description">
              <p className="needSpace">
                Understanding the meta is key. Pay attention to which champions
                are strong in the current patch, which lane matchups favor which
                side, and how team compositions synergize together.
              </p>
              <p>
                Use the Drafting Lab to experiment with different compositions
                without risking your Elo. Study professional drafts on sites
                like gol.gg to see how pro coaches approach champion select.
                Over time, you&apos;ll develop an intuition for which picks
                counter your opponent&apos;s strategy.
              </p>
            </h2>
          </div>
          <div className="descriptionContainer">
            <h3 className="descriptionTitle">How does the algorithm work?</h3>
            <h2 className="description">
              <p className="needSpace">
                DrafterEye, our prediction engine, uses a sophisticated model
                trained on data from professional League of Legends matches
                across all major regions. It evaluates every possible
                interaction between the 10 champions in a draft.
              </p>
              <p>
                The model considers lane matchups (how champions perform
                head-to-head), team synergies (how well champions work
                together), and opposition dynamics (how one team&apos;s
                composition counters the other). All of this is weighted by
                recency to reflect the current meta.
              </p>
            </h2>
          </div>
          <div className="descriptionContainer">
            <h3 className="descriptionTitle">Disclaimer</h3>
            <h2 className="description">
              Drafter is not endorsed by Riot Games and doesn&apos;t reflect the
              views or opinions of Riot Games or anyone officially involved in
              producing or managing Riot Games properties. Riot Games, and all
              associated properties are trademarks or registered trademarks of
              Riot Games, Inc.
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
